import useAppLinks from 'hooks/useAppLinks'
import { useRouter } from 'next/router'
import { FC } from 'react'
import { isAndroid, isIOS } from 'react-device-detect'
import Image from 'next/image'
import Illustration from 'atomic/components/atoms/illustrations/Illustration'
import { trackOutboundLink } from 'lib/gtag'
import AppstoreIcon from '../icons/AppStore'
import GooglePlayIcon from '../icons/GooglePlay'

import styles from './AppBadges.module.scss'
import { useSafeTranslation } from 'hooks/useSafeTranslation'
import { ouTheme } from 'atomic/styles/theme.css'

const AppBadges: FC = () => {
  const router = useRouter()
  const { appStoreUrl, googlePlayUrl } = useAppLinks()
  const { t } = useSafeTranslation()

  return (
    <div className={styles.badges}>
      <a
        onClick={() => trackOutboundLink(appStoreUrl)}
        href={appStoreUrl}
        aria-label="Link to Appstore"
        aria-hidden={isAndroid}
        className={isIOS && !isAndroid ? null : styles.hidden}
      >
        <AppstoreIcon locale={router.locale} />
      </a>
      <a
        onClick={() => trackOutboundLink(googlePlayUrl)}
        href={googlePlayUrl}
        aria-label="Link to Google Play"
        aria-hidden={isIOS}
        className={isAndroid && !isIOS ? null : styles.hidden}
      >
        <GooglePlayIcon locale={router.locale} />
      </a>
      <div className={isAndroid || isIOS ? styles.hidden : styles.qrCodeContainer}>
        <Image
          src="/images/getapp_qr_code.svg"
          width={150}
          height={150}
          alt="Get app QR code"
          sizes={`(max-width: ${ouTheme.breakpoints.tablet}) 100vw, 50vw`}
          loading="lazy"
          fetchPriority="low"
        />
        <div className={styles.arrow}>
          <span>{t('collaboration_invitation_web_qrcta')}</span>
          <Illustration name="arrow-11" />
        </div>
      </div>
    </div>
  )
}

export default AppBadges
